import axios from 'axios'

export const openWeatherApi = axios.create({
  baseURL: 'https://api.openweathermap.org/data/2.5',
  params: {
    appid: 'be56ce65affba360fcfb08d130f572b1',
  },
})
